import { mapState, mapGetters, mapActions } from "vuex";

export const localize = {
  data: function () {
    return {
      gCollectingItem: -1
    }
  },

  methods: {
    ...mapActions([
      "initAUID"
    ]),
    localize(str) {
      //return this.siteLang;
      //return 'xxxx'+str;//
      //if (!this.localizedUIReady) {return null;}
      let dicArray = this.siteDic.dictionary;
      //return "dicArray="+dicArray.length;
      //return dicArray[0]['en'];

      let tag = str.toLowerCase().replace(/(\s|-)/g, "_");
      tag = tag.substring(1);//remove the init @
      let obj1 = _.find(dicArray, { 'tag': tag });
      if(obj1)
      {
        let trans = obj1[this.siteLang.toLowerCase()];
        if(trans){
          return trans;
        }else{
          return obj1['en'];//take default if translation not exist
        }        
      }

      //let obj = _.find(dicArray, { tag });
      //if (obj) {
        //return obj.en;///<<<<<<<replace the lang by this.siteLang
      //}

      return str;
      // return null;
    },

    //Manage products collections
    createCollection(collection_name)
    {        
        alert("collection_name="+collection_name);//check if name exists
    },
    addProductToCollection(pro_id)
    {
        this.initAUID();//INIT THE AUID BEFOR CALLING THE API
        alert("adding item:"+pro_id +" auid:"+this.auid);

    },
    getProductsCollection() 
    {
        //alert("adding item:"+pro_id);
    },
    shareProductsCollection() 
    {
        //alert("adding item:"+pro_id);
    }

  },
  computed: {
    ...mapState(["siteDic","siteData","siteLang"])
  }
};
